module.exports = __webpack_public_path__ + "img/proyecto_10.775e5376.png";